<script setup></script>
<template>
    <svg width="50" height="49" viewBox="0 0 50 49" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M35.3125 18.875L21.5547 32L14.6875 25.4375" stroke="#F2CD59" stroke-width="3.21429" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M25 47C37.4264 47 47.5 36.9264 47.5 24.5C47.5 12.0736 37.4264 2 25 2C12.5736 2 2.5 12.0736 2.5 24.5C2.5 36.9264 12.5736 47 25 47Z" stroke="#F2CD59" stroke-width="3.21429" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>